export default __webpack_public_path__ + "static/media/eyes.2e1117f6.JPG";